import { createFileRoute } from "@tanstack/react-router";

import EndOfTrialPage from "@/components/Onboarding/EndOfTrialPage";

export const Route = createFileRoute("/_auth/end-of-trial")({
  validateSearch: (search) =>
    search as {
      redirect?: string;
    },
  component: EndOfTrialPage,
});
